<template>
	<div class="image-upload-box clearfix">
		<div class="image fl">
			<el-image v-if="$utils.getFileType(urlFull) != 'pdf' && $utils.getFileType(urlFull) != 'ofd'" :src="urlFull"
				:fit="fit" v-loading="uploadLoading" :preview-src-list="[...urlFull]">
				<div slot="error" class="image-slot">
					<i class="el-icon-picture-outline"></i>
				</div>
			</el-image>
			<pdf :src="urlFull" v-else-if="$utils.getFileType(urlFull) === 'pdf'"></pdf>
			<div v-else-if="$utils.getFileType(urlFull) === 'ofd'" class="ofd-preview" @click="preview">
				<i class="el-icon-document"></i>
				<span>OFD文件</span>
			</div>
			<div v-if="urlFull" class="tool">
				<div>
					<span class="img-preview el-icon-zoom-in" @click="preview"></span>
					<el-button v-if="!disabled" icon="el-icon-delete" type="text" @click="remove"></el-button>
				</div>
			</div>
		</div>
		<div class="image-upload-content">
			<ul>
				<li>
					<i :class="formatVerified | verified"></i>
					格式: <slot name="type">支持格式为{{ acceptText }}</slot>
				</li>
				<li>
					<i :class="sizeVerified | verified"></i>
					尺寸:
					<slot v-if="!width && !height && !minWidth && !minHeight" name="size">
						无特殊要求
					</slot>
					<slot v-else name="size">
						{{minWidth && minHeight ? '不小于'+minWidth+'*'+minHeight+'px' : ''}}
						{{maxWidth && maxHeight ? '不大于'+maxWidth+'*'+maxHeight+'px' : ''}}
						{{width && height ? '必须为'+width+'*'+height+'px' : ''}}
					</slot>
				</li>
				<li>
					<i :class="bytesVerified | verified"></i>
					大小: 大小不超过{{bytes}}M
				</li>
				<li>
					<slot name="tips"></slot>
				</li>
			</ul>
			<template v-if="progress && progress < 100 && uploadLoading">
				<el-progress :percentage="progress"></el-progress>
			</template>
			<div class="image-upload-btn">
				<!-- <el-button v-if="isClear" icon="el-icon-delete" @click="remove">删除</el-button> -->
				<el-upload action :accept="accept" :http-request="uploadFile" :show-file-list="false"
					:disabled="uploadLoading" :before-upload="beforeImageUpload">
					<el-button type="primary" icon="el-icon-upload" size="small"
						:disabled="disabled">{{url ? '重新上传' : '点击上传'}}</el-button>
				</el-upload>
				<slot></slot>
			</div>
		</div>

		<el-dialog title="裁剪图片" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :width="parseInt(cropperBoxWidth + 40)+'px'"
			append-to-body>
			<div class="cropper-content" :style="{height:cropperBoxHeight+'px'}">
				<vue-cropper ref="cropper" :img="copperOptions.img" :fixed="true" :auto-crop="true" output-type="png"
					:fixed-number="copperOptions.fixedNumber" :centerBox="false" :info="false" :fixedBox="true"
					:auto-crop-width="cropperBoxWidth" :auto-crop-height="cropperBoxHeight"
					:enlarge="copperOptions.enlarge"></vue-cropper>
			</div>
			<div v-if="width && height" style="text-align:center; color:#409EFF; font-size:14px; margin-top:8px;">
				裁剪尺寸：{{ width }} × {{ height }} px
			</div>
			<template v-if="progress && progress < 100 && uploadLoading">
				<el-progress :percentage="progress"></el-progress>
			</template>
			<div slot="footer" class="dialog-footer clearfix">
				<div class="tool fl">
					<el-button icon="el-icon-zoom-in" @click="changeScale(1)"></el-button>
					<el-button icon="el-icon-zoom-out" @click="changeScale(-1)"></el-button>
					<el-button icon="el-icon-refresh-left" @click="rotateLeft"></el-button>
					<el-button icon="el-icon-refresh-right" @click="rotateRight"></el-button>
				</div>
				<div class="btn fr">
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="finish" :loading="uploadLoading">确定</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="previewVisible" title="高清预览" center append-to-body>
			<div class="preview-box">
				<!-- PDF 已改为新窗口预览，此处仅处理 OFD 和图片 -->
				<div v-if="urlFull && $utils.getFileType(urlFull) == 'ofd'" style="max-width: 100%;">
					<cafe-ofd :file-path="urlFull" style="height: 80vh; width: 100%;" />
				</div>
				<img v-else :src="urlFull">
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		uploadImg,
		uploadImgByBase64,
		uploadFile
	} from '@/assets/js/commonApi.js';
	import {
		VueCropper
	} from 'vue-cropper'
	import pdf from 'vue-pdf'
	import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'

	export default {
		filters: {
			verified(v) {
				if (v === null) {
					return ["el-icon-warning-outline"];
				} else if (v === false) {
					return ["el-icon-circle-close", "error"];
				} else {
					return ["el-icon-circle-check", "success"];
				}
			},
		},
		props: {
			// 图片相对路径
			url: {
				type: String,
				default: () => "",
			},
			fit: {
				type: String,
				default: 'contain',
			},
			// 图片全路径
			urlFull: {
				type: String,
				default: () => "",
			},
			// 上传图片最小宽度
			minWidth: {
				type: Number,
				default: null
			},
			// 上传图片最小高度
			minHeight: {
				type: Number,
				default: null
			},
			// 上传图片最大宽度
			maxWidth: {
				type: Number,
				default: null
			},
			// 上传图片最大高度
			maxHeight: {
				type: Number,
				default: null
			},
			// 上传图片要求宽度
			width: {
				type: Number,
				default: null
			},
			// 上传图片要求高度
			height: {
				type: Number,
				default: null
			},
			// 是否可删除
			// isClear:{
			//     type: Boolean,
			//     default: false
			// },
			// 是否需要裁剪
			crop: {
				type: Boolean,
				default: false
			},
			// 原图路径
			original: {
				type: String,
				default: () => null,
			},
			//上传成功回调
			// onSuccess:{
			//     type: Function,
			//     default: () => {}
			// },
			accept: {
				type: String,
				default: 'image/png, image/jpeg, image/gif',
			},
			//是否禁用
			disabled: {
				type: Boolean,
				default: false
			},
			bytes: {
				type: Number,
				default: 10
			}
		},
		components: {
			VueCropper,
			pdf
		},
		data() {
			return {
				uploadLoading: false,
				formatVerified: null,
				sizeVerified: null,
				bytesVerified: null,
				progress: null,
				dialogVisible: false,
				copperOptions: {
					img: '',
					fixedNumber: [this.width || this.minWidth || 1, this.height || this.minHeight || 1],
					cropWidth: this.width || this.minWidth,
					cropHeight: this.height || this.minHeight,
					enlarge: ''
				},
				previewVisible: false,
				imageObj: null,
				numPages: null, // pdf 总页数
				pdfUrl: '',
				cropperBoxWidth: 600,
				cropperBoxHeight: 400
			};
		},
		mounted() {
			if (this.urlFull && this.$utils.getFileType(this.urlFull) == 'pdf') {
				this.getNumPages();
			}
		},
		watch: {

			width: {
				immediate: true,
				handler() {
					// 用于统一页面更新宽高后，更新重新计算裁切比例
					this.copperOptions = {
						img: '',
						fixedNumber: [this.width || this.minWidth || 1, this.height || this.minHeight || 1],
						cropWidth: this.width || this.minWidth,
						cropHeight: this.height || this.minHeight,
						enlarge: ''
					}
					this.resetRatio();
				}
			}
		},
		computed: {
			acceptText() {
				return this.accept.split(',').map(item => item.split('/')[1].toLocaleUpperCase()).toString();
			},

		},
		methods: {
			resetRatio() {
				if (this.copperOptions.cropWidth > this.copperOptions.cropHeight) {
					this.copperOptions.enlarge = this.copperOptions.cropWidth > this.cropperBoxWidth ? this.copperOptions
						.cropWidth / this.cropperBoxWidth : 1
				} else {
					this.copperOptions.enlarge = this.copperOptions.cropHeight > this.cropperBoxHeight ? this.copperOptions
						.cropHeight / this.cropperBoxHeight : 1
				}
			},
			async beforeImageUpload(file) {

				//格式检查
				let _accept = this.accept.split(',') || [];
				_accept.map((item, index) => {
					_accept[index] = item.trim();
				})
				this.formatVerified = _accept.find(v => v == file.type);
				if (!this.formatVerified) {
					this.$message.error("文件格式错误,请重新上传");
					//return;
				}
				//大小检查
				this.bytesVerified = file.size / 1024 / 1024 <= this.bytes;
				if (!this.bytesVerified) {
					this.$message.error("文件大小错误,请重新上传");
					//return;
				}

				if (this.formatVerified == 'image/png' || this.formatVerified == 'image/jpeg') {
					const {
						width,
						height
					} = await new Promise((resolve) => {
						const _URL = window.URL || window.webkitURL;
						const img = new Image();
						img.onload = () => {
							const {
								naturalWidth,
								naturalHeight
							} = img;
							resolve({
								width: naturalWidth,
								height: naturalHeight
							});
						};
						img.src = _URL.createObjectURL(file);
						this.copperOptions.img = _URL.createObjectURL(file);
					});

					const _minW = this.minWidth ? width >= this.minWidth : true;
					const _minH = this.minHeight ? height >= this.minHeight : true;
					const _maxW = this.maxWidth ? width <= this.maxWidth : true;
					const _maxH = this.maxHeight ? height <= this.maxHeight : true;
					const _w = this.width ? width == this.width : true;
					const _h = this.height ? height == this.height : true;

					this.sizeVerified = !this.crop ? _minW && _minH && _maxW && _maxH && _w && _h : true;

					if (!this.sizeVerified) {
						this.$message.error("文件尺寸错误,请重新上传");
						//return;
					}
				} else {
					this.sizeVerified = true;
				}

				if (this.formatVerified && this.bytesVerified && this.sizeVerified && this.crop) {
					this.dialogVisible = true;
					this.imageObj = file;
				}

				return this.formatVerified && this.bytesVerified && this.sizeVerified;
			},

			setProgress(ev) {
				this.progress = Math.floor((ev.loaded / ev.total) * 20);
				if (Math.floor((ev.loaded / ev.total)) == 1) {
					let t = setInterval(() => {
						if (this.progress < 99 && this.uploadLoading) {
							this.progress += 1;
						} else {
							clearInterval(t);
						}
					}, 1000)
				}
			},

			async uploadFile(req, type) {
				if (this.formatVerified && this.bytesVerified && this.sizeVerified && (type && this.crop || !type && !
						this.crop)) {
					let res;
					this.uploadLoading = true;
					const formData = new FormData();

					this.progress = 0;

					if (type == 1) {
						const arr = req.split(',');
						const mime = arr[0].match(/:(.*?);/)[1] || 'image/png';
						const bstr = atob(arr[1]);
						let n = bstr.length;
						const u8arr = new Uint8Array(n);
						while (n--) {
							u8arr[n] = bstr.charCodeAt(n);
						}
						const blob = new Blob([u8arr], {
							type: mime
						});
						const file = new File([blob], `cropped.${mime.split('/')[1] || 'png'}`, {
							type: mime
						});
						formData.append('file', file);

						// ===== 关键修改：使用 uploadFile（通用接口）而非 uploadImg =====
						res = await uploadFile(formData, (ev) => {
							this.progress = Math.floor((ev.loaded / ev.total) * 100);
						}).catch(() => {
							this.$message.error('上传失败');
						}).finally(() => {
							this.uploadLoading = false;
						});

					} else {
						const {
							file
						} = req;
						formData.append("file", file || req);
						res = this.formatVerified == 'image/png' || this.formatVerified == 'image/jpeg' ?
							await uploadImg(formData, ev => {
								// this.progress = Math.floor((ev.loaded / ev.total) * 100);
								this.setProgress(ev);
							}).catch(() => {
								this.$message.error('上传失败');
							}).finally(() => {
								this.progress = 99;
								setTimeout(() => {
									this.uploadLoading = false;
								}, 800);
							}) :
							await uploadFile(formData, ev => {
								// this.progress = Math.floor((ev.loaded / ev.total) * 100);
								this.setProgress(ev);
							}).catch(() => {
								this.$message.error('上传失败');
							}).finally(() => {
								this.progress = 99;
								setTimeout(() => {
									this.uploadLoading = false;
								}, 800);
							});
					}

					const {
						state,
						result,
						msg
					} = res.data;
					if (state == 1) {
						if (type != 3) {
							this.$emit(
								"update:url",
								result.url
							);
							this.$emit(
								"update:urlFull",
								result.urlFull
							);
						} else { //裁剪前的原图
							this.$emit(
								"update:original",
								result.url
							);
						}

						this.$emit('onSuccess', req, result)

						if (this.$utils.getFileType(result.urlFull) == 'pdf') {
							this.getNumPages(result.urlFull);
						}
					} else {
						this.$message.error(msg || '上传失败');
					}
				}

			},
			//清除
			remove() {
				this.$emit(
					"update:url", ""
				);
				this.$emit(
					"update:urlFull", ""
				);
				this.formatVerified = this.sizeVerified = this.bytesVerified = null;
			},
			//预览
			preview() {
				//PDF 使用浏览器新窗口预览，不再走弹窗
				if (this.urlFull && this.$utils.getFileType(this.urlFull) == 'pdf') {
					window.open(this.urlFull, '_blank');
					return;
				}
				this.previewVisible = true
			},
			//完成裁剪
			finish() {
				if (this.original != null) {
					this.uploadFile(this.imageObj, 3);
				}
				this.$refs.cropper.getCropData(async (data) => {
					let imgData = data;
					if (this.width && this.height) {
						imgData = await this.resizeImage(data, this.width, this.height);
						// 验证：创建一个图片并显示在页面上（临时）
						const img = new Image();
						img.src = imgData;
					}
					// 继续上传
					await this.uploadFile(imgData, 1);
					this.dialogVisible = false;
				});
			},
			resizeImage(base64, targetWidth, targetHeight) {
				return new Promise((resolve) => {
					const img = new Image();
					img.onload = () => {
						const canvas = document.createElement('canvas');
						canvas.width = targetWidth;
						canvas.height = targetHeight;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
						resolve(canvas.toDataURL('image/png'));
					};
					img.src = base64;
				});
			},
			// handleImageSuccess(res,file,fileList){
			//     console.log(res)
			//     this.$emit('onSuccess',res,file,fileList)
			//     //this.onSuccess(res,file,fileList);
			// },
			//裁剪图片放大、缩小
			changeScale(num) {
				num = num || 1
				this.$refs.cropper.changeScale(num)
			},
			//裁剪图片左旋转
			rotateLeft() {
				this.$refs.cropper.rotateLeft();
			},
			//裁剪图片右旋转
			rotateRight() {
				this.$refs.cropper.rotateRight();
			},
			// 计算pdf页码总数
			getNumPages(_url) {
				const url = _url || this.urlFull;
				this.pdfUrl = pdf.createLoadingTask({
					url: url,
					CMapReaderFactory
				});
				let loadingTask = pdf.createLoadingTask(url)
				loadingTask.promise.then(pdf => {
					this.numPages = pdf.numPages
				}).catch(err => {
					console.error('pdf 加载失败', err);
				})
			},
		},
	};
</script>
<style lang="scss" scoped>
	.image-upload-box {
		.image {
			width: 200px;
			height: 200px;
			margin-right: 15px;
			display: flex;
			align-content: center;
			align-items: center;
			justify-content: center;
			background: #f7f7f7;
			border-radius: 8px;
			position: relative;
			overflow: hidden;

			.el-image {
				width: 100%;
				height: 100%;
			}

			.ofd-preview {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				color: #999;
				cursor: pointer;

				i {
					font-size: 48px;
					margin-bottom: 10px;
				}

				span {
					font-size: 14px;
				}

				&:hover {
					color: #409EFF;
				}
			}

			.tool {
				position: absolute;
				background: rgba(0, 0, 0, 0.5);
				width: 100%;
				height: 100%;
				left: 0;
				top: 0;
				display: none;
				align-items: center;
				justify-content: center;

				.el-button,
				.img-preview {
					color: #ffffff;
					font-size: 18px;
					font-weight: 700;
					margin: 0 5px;
				}

				.img-preview {
					cursor: pointer;
				}
			}

			&:hover {
				.tool {
					display: flex;
				}
			}
		}

		.image-upload-content {
			// background: #FCFCFC;
			// border-radius: 8px;
			overflow: hidden;
			// float: left;
			// padding: 20px;
			position: relative;
			height: 200px;

			ul {
				li {
					line-height: normal;
					color: #999;
					margin-bottom: 5px;
					font-size: 13px;

					i {
						&.error {
							color: #f56c6c;
						}

						&.success {
							color: #67c23a;
						}
					}
				}
			}

			.image-upload-btn {
				position: absolute;
				left: 0px;
				bottom: 0px;
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				align-items: center;

				// margin-top: 50px;
				// &.flex{
				//     display: flex;
				// }
				// .el-button{
				//     margin-right: 10px;
				// }
				::v-deep .el-upload {

					// width: 150px;
					.el-button {
						width: 100%;
						margin: 0;
					}
				}

				// .only{
				//     ::v-deep .el-upload{
				//         width: 100%;
				//     }   
				// }
			}
		}
	}

	// @media screen and (max-width: 768px) {
	//     .image-upload-box{
	//         .image-upload-content{
	//             ul{
	//                 margin-top: 10px;
	//             }
	//             .image-upload-btn{
	//                 margin-top: 10px;
	//             }
	//         }
	//     }
	// }


	.cropper-content {
		height: 400px;
		width: auto;
	}

	.preview-box {
		text-align: center;

		img {
			max-width: 100%;
		}
	}
</style>